import {
  jb_article_share_bar_css_default
} from "./chunk.N7OM73L7.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-article-share-bar/jb-article-share-bar.ts
var JbArticleShareBar = class extends r {
  constructor() {
    super(...arguments);
    this.ARIALABELS_DEFAULT = {
      bluesky: "Share this article on BlueSky",
      facebook: "Share this article on Facebook",
      linkedin: "Share this article on LinkedIn",
      mail: "Share this article via email",
      x: "Share this article on X"
    };
  }
  _getShareLinkByService(item) {
    switch (item.service) {
      case "bluesky":
        return {
          href: `https://bsky.app/intent/compose?text=${encodeURI(this.url)}`,
          target: "_blank",
          name: this.ariaLabel ?? this.ARIALABELS_DEFAULT.bluesky
        };
      case "mail":
        return {
          href: `mailto:?subject=[${this.mailSubject}]%20${encodeURI(this.articleTitle)}&amp;body=${this.url}`,
          name: this.ariaLabel ?? this.ARIALABELS_DEFAULT.mail
        };
      case "facebook":
        return {
          href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(this.url)}`,
          target: "_blank",
          name: this.ariaLabel ?? this.ARIALABELS_DEFAULT.facebook
        };
      case "linkedin":
        return {
          href: `https://www.linkedin.com/shareArticle/?mini=true&amp;url=${encodeURI(this.url)}&amp;title=${encodeURI(this.articleTitle)}&amp;summary=&amp;source=web`,
          target: "_blank",
          name: this.ariaLabel ?? this.ARIALABELS_DEFAULT.linkedin
        };
      case "x":
        return {
          href: `https://x.com/share?text=${encodeURI(`${this.articleTitle} ${this.url}`)}`,
          target: "_blank",
          name: this.ariaLabel ?? this.ARIALABELS_DEFAULT.x
        };
      default:
        return { href: "#", name: this.ariaLabel ?? "" };
    }
  }
  _renderShareIcons(items) {
    const iconItems = items.map((item) => ({
      service: item.service,
      link: this._getShareLinkByService(item),
      ariaLabels: {
        label: item.ariaLabels?.label ?? this.ARIALABELS_DEFAULT[item.service] ?? D
      }
    }));
    return ke`<jb-social-icons
      .items=${iconItems}
      @jb-social-icons:clicked=${(e) => this._trackClick(e)}
    ></jb-social-icons>`;
  }
  _trackClick(event) {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_interaction",
          event_version: "v2",
          component_name: "article-share-bar",
          interaction_effect: "share",
          interaction_element: "icon",
          interaction_result: event.detail.service,
          interaction_type: "click"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    if (this.shareServices.length === 0) {
      return "";
    }
    return ke`
      ${this.title ? ke`<span class="title">${this.title.toLowerCase()}</span>` : D}
      ${this._renderShareIcons(this.shareServices)}
    `;
  }
};
JbArticleShareBar.styles = [reset_css_default, jb_article_share_bar_css_default];
__decorateClass([
  n()
], JbArticleShareBar.prototype, "articleTitle", 2);
__decorateClass([
  n()
], JbArticleShareBar.prototype, "mailSubject", 2);
__decorateClass([
  n({ type: Array })
], JbArticleShareBar.prototype, "shareServices", 2);
__decorateClass([
  n()
], JbArticleShareBar.prototype, "title", 2);
__decorateClass([
  n()
], JbArticleShareBar.prototype, "url", 2);
JbArticleShareBar = __decorateClass([
  customElement("jb-article-share-bar")
], JbArticleShareBar);

export {
  JbArticleShareBar
};
